import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const PaymentSuccess = () => {
  return (
    <div className="container" style={{ paddingTop: '80px' }}>
      <div className="card text-center">
        <CheckCircle size={64} color="var(--success)" style={{ margin: '0 auto 24px' }} />
        <h1>Payment Successful!</h1>
        <p className="text-muted" style={{ margin: '16px 0' }}>
          Your order has been confirmed.
        </p>
        <Link to="/my-orders" className="btn btn-primary">
          View My Orders
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
